import { render, staticRenderFns } from "./procuradeexames.vue?vue&type=template&id=6b00a542"
import script from "./procuradeexames.vue?vue&type=script&lang=js"
export * from "./procuradeexames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports